import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=db3d2c38&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=db3d2c38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3d2c38",
  null
  
)

export default component.exports